import { notification } from 'antd';
import Router from 'next/router';

import request from '@/utils/axios';

export default payload => {
  return async () => {
    try {
      await request({
        url: 'askus/submitrequest',
        method: 'POST',
        data: payload,
      }).then(response => {
        const { data } = response;
        if (data.Success && data.Success === 'true') {
          notification.success({
            message: 'Success',
            description: data.Message,
          });
          const confirmationURL = '/about/contact-us/form/submission-confirmation';
          Router.push(confirmationURL, confirmationURL);
        }
        if (data.Success && data.Success === 'false') {
          notification.error({
            message: 'Error',
            description: data.Message,
          });
        }
      });
    } catch (err) {
      throw err;
    }
  };
};
